import { useMutation } from "@tanstack/react-query";
import {
  rmPdCtModifyApi,
  rmPdHistsApi,
  rmPdSellPriModifyApi,
  rmPdStaModifyApi,
} from "components/api/rm";
import { apifield } from "components/utils/comm";
import useAlertStore from "store/alert";
import useModalStore from "store/modal";
import { useCalendarCardInfContext } from "../context";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useUserStore from "store/user";

// 상태변경
export const useUpdateStatusApi = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const setIsOpen = useModalStore((state) => state.handleModal);
  return useMutation({
    mutationKey: ["product-status-update"],
    mutationFn: rmPdStaModifyApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          // 상태변경 완료 , 해당 상태 업데이트
          onSetAlert({
            isOpen: true,
            inner: "상품상태를 수정 완료하였습니다.",
            onSetConfirm: () => {
              setIsOpen(false);
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

// 상품수량 변경

export const useUpdateCntApi = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const setIsOpen = useModalStore((state) => state.handleModal);

  return useMutation({
    mutationKey: ["product-count-update"],
    mutationFn: rmPdCtModifyApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          // 성공
          onSetAlert({
            isOpen: true,
            inner: "상품수량변경을 완료하였습니다.",
            onSetConfirm: () => {
              setIsOpen(false);
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

// 상품가격 변경
export const useUpdatePriceApi = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const setIsOpen = useModalStore((state) => state.handleModal);
  return useMutation({
    mutationKey: ["product-price-update"],
    mutationFn: rmPdSellPriModifyApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          // 상품가격 변경 성공
          onSetAlert({
            isOpen: true,
            inner: "상품가격변경을 완료하였습니다.",
            onSetConfirm: () => {
              setIsOpen(false);
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

// 상품이력 상세조회
export const useGetProductHistoryData = () => {
  const { t } = useTranslation();
  const { cardInf } = useCalendarCardInfContext();
  const user = useUserStore((state) => state.user);

  const [rowData, setRowData] = useState<any[]>([]);
  const mutation = useMutation({
    mutationKey: ["room-product-history-search"],
    mutationFn: rmPdHistsApi,
    onSuccess: (res) => {
      if (res) {
        const rmPdHistList = res.data.rmPdHistList;
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          //
          setRowData(
            [...rowData, ...rmPdHistList].map((row, index) => {
              return {
                No: index + 1,
                ...row,
                histStaTypNm:
                  row.histStaTyp === "U"
                    ? t("txt_update")
                    : row.histStaTyp === "C"
                    ? t("txt_create")
                    : row.histStaTyp === "D"
                    ? t("txt_delete")
                    : "",
              };
            })
          );
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  const params = {
    lodGrpNo: user?.manLodGrpNo,
    lodChlCd: cardInf?.lodChlCd,
    rmNo: cardInf?.rmNo,
    opRgSeq: cardInf?.opRgSeq,
    rmOpNm: "",
    sellSDt: cardInf?.sellDt,
    sellEDt: cardInf?.sellDt,
    pageNo: 1,
    pageRows: 40,
  };
  useEffect(() => {
    if (cardInf) {
      mutation.mutate(params);
    }
  }, [cardInf]);

  return {
    rowData,
  };
};
